import { render } from "./MapMarkerBlueIcon.vue?vue&type=template&id=645694b6"
import script from "./MapMarkerBlueIcon.vue?vue&type=script&lang=js"
export * from "./MapMarkerBlueIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__